import { CAPostalCodeRegexMask, CAPostalCodeRegexMaskWithoutSpace } from "../constants";

export function getMask(value: string) {
    return value.indexOf(" ") !== -1 ? CAPostalCodeRegexMask : CAPostalCodeRegexMaskWithoutSpace;
}

export function shouldInsertSpace(value: string) {
    return value.length === 6 && value.indexOf(" ") === -1;
}

export function insertSpace(value: string) {
    return `${value.substr(0, 3)} ${value.substr(3, 3)}`;
}
